import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { toogleMenu } from "../../../../actions/layoutAction";
import { withRouter } from "../../../../utils/utility";
import * as Icon from "react-feather";
import SidebarToggle from "../admin/SidebarToggle";
import "../admin/adminSidebar.scss";

const SIDEBAR_STORAGE_KEY = "meetocto.superAdminSidebarExpanded";

const NAV_ITEMS = [
  {
    to: "/super-admin/dashboard",
    label: "My Dashboard",
    iconClass: "dashboardmenuicon",
  },
  {
    to: "/super-admin/subscriber",
    label: "Users Details",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/promos",
    label: "Coupon Details",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/plan-manager",
    label: "Plan Manager",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/referral-program",
    label: "Referral Program",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/settings",
    label: "System Settings",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/notification-templates",
    label: "Notification Templates",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/feature-requests",
    label: "Feature Requests",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/launch-health",
    label: "Launch Health",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/launch-analytics",
    label: "Launch Analytics",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/alert-settings",
    label: "Alert Settings",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/sms-packages",
    label: "SMS Packages",
    iconClass: "calendarmenuicon",
  },
  {
    to: "/super-admin/staff-calendar",
    label: "Staff Calendar",
    iconClass: "calendarmenuicon",
  },
];

class SuperAdminLeftMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      extended: true,
    };
  }

  componentDidMount() {
    let extended = true;

    try {
      const stored = window.localStorage.getItem(SIDEBAR_STORAGE_KEY);
      if (stored !== null) {
        extended = stored === "1";
      }
    } catch (error) {
      extended = true;
    }

    this.props.toogleMenu(extended);
    this.setState({ extended });
  }

  toggleExtended = () => {
    this.setState((prevState) => {
      const extended = !prevState.extended;
      this.props.toogleMenu(extended);

      try {
        window.localStorage.setItem(SIDEBAR_STORAGE_KEY, extended ? "1" : "0");
      } catch (error) {
        // ignore storage failures
      }

      return { extended };
    });
  };

  renderNavLabel = (text) => (
    <span className="admin-sidebar__nav-label">{text}</span>
  );

  renderLogoutBtn = (collapsed = false) => (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        this.props.userLogout();
      }}
      className={`admin-sidebar__logout ${
        collapsed ? "admin-sidebar__logout--collapsed" : ""
      }`}
      aria-label="Logout"
      data-sidebar-tooltip={collapsed ? "Logout" : undefined}
    >
      <Icon.LogOut size={18} />
      <span>Logout</span>
    </a>
  );

  renderNav = (pathname, extended) => (
    <div className="ul-listitemmenu">
      {NAV_ITEMS.map(({ to, label, iconClass }) => (
        <Link
          key={to}
          to={to}
          className={
            `itemcomconsub ${iconClass} ` + (pathname === to ? "active" : "")
          }
          data-sidebar-tooltip={!extended ? label : undefined}
        >
          {this.renderNavLabel(label)}
        </Link>
      ))}
    </div>
  );

  render() {
    const { router } = this.props;
    const { pathname } = router.location;
    const { extended } = this.state;

    return (
      <div
        className={`admin-sidebar-rail d-none d-md-block ${
          extended ? "admin-sidebar-rail--expanded" : "admin-sidebar-rail--collapsed"
        }`}
      >
        <aside
          id="super-admin-primary-sidebar"
          className={`sidemenu admin-sidebar ${
            extended ? "admin-sidebar--expanded" : "admin-sidebar--collapsed"
          }`}
        >
          <div className="admin-sidebar__inner">
            <div className="admin-sidebar__scroll">
              {this.renderNav(pathname, extended)}
            </div>
            <div className="admin-sidebar__footer">
              {this.renderLogoutBtn(!extended)}
            </div>
          </div>
        </aside>
        <SidebarToggle
          expanded={extended}
          onToggle={this.toggleExtended}
          sidebarId="super-admin-primary-sidebar"
        />
      </div>
    );
  }
}

const actionMethods = {
  toogleMenu,
};

export default connect(null, actionMethods)(withRouter(SuperAdminLeftMenu));
